// extracted by mini-css-extract-plugin
module.exports = {"dialectNoficiation":"Dialect_dialectNoficiation___jr7Q","dialect":"Dialect_dialect___B6bB"};